<a role="button" [hidden]="hidden" class="btn" (click)="bringVideoPlayerToFront()">
  <div class="video-player-icon">
    <i class="fad fa-video fa-lg"></i>
  </div>
</a>
